const routes = [
  {
    index: true,
    label: "IndexRoute",
    path: "/",
  },
  {
    label: "AboutRoute",
    path: "/about",
  },
  {
    label: "ResumeRoute",
    path: "/resume",
  },
  // {
  //   label: 'ProjectsRoute',
  //   path: '/projects',
  // },
  {
    label: "ContactRoute",
    path: "/contact",
  },
  {
    label: "SwitchLanguageRoute",
    path: "/lang",
  },
];

export default routes;
